import React, { useState } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import '../Global.css';
import api from '../api';
const CreateTournament = () => {
    const categories = ["Müzik", "Spor", "Para", "Eğlence", "Genel Kültür", "Sinema & Dizi", "Music", "Sports", "Money", "Fun", "General", "Movies and Shows"];
    const types = ["standart", "top-artist"];
    const languages = ["en", "tr", "pl"];
    const [apiNo, setApiNo] = useState(null)
    const [cekilecekMiktar, setCekilecekMiktar] = useState(64);

    const [formData, setFormData] = useState({
        title: '',
        category: '',
        type: 'standart',
        image: '',
        visibility: "public",
        language: "en",
        platform: "quizei"
    });



    const [decisions, setDecisions] = useState([
        { title: '', image: '', winAmount: 0 },
        { title: '', image: '', winAmount: 0 }
    ]);

    // React Admin Paneli - Gönderim Fonksiyonu
    const handleUwufufuImport = async () => {
        try {
            const payload = {
                ...formData,
                uwufufuId: apiNo, // Sadece bu ID'yi gönderiyoruz, gerisini backend hallediyor!,
                cekilecekMiktar
            };
            let importUrl;

            if (formData.platform === "uwufufu") {
                importUrl = "https://api.turnaments.com/v1/admin/import"
            } else {
                importUrl = "https://api.turnaments.com/v1/admin/import/quizei"

            }

            const res = await axios.post(
                importUrl,
                payload,
                { headers: { Authorization: `Bearer ${localStorage.getItem('JWTTOKEN')}` } }
            );

            if (res.data.status === "success") {
                alert(`Harika! Turnuva oluşturuldu. Slug: ${res.data.slug}`);
            }
        } catch (error) {
            console.error("Import hatası:", error);
            alert("Turnuva yüklenirken bir hata oluştu!");
        }
    };

    // Dosya Yükleme Fonksiyonu
    const handleFileUpload = async (e, target, index = null) => {
        const file = e.target.files[0];
        if (!file) return;

        const uploadData = new FormData();
        uploadData.append('file', file);

        try {
            const response = await api.post('/v1/util/uploadImage', uploadData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${localStorage.getItem('JWTTOKEN')}`
                }
            });

            const BASE_URL = "https://images.turnaments.com";
            console.log(BASE_URL + response.data.data.filePath);

            // Backend'den gelen yolu tam URL'e çeviriyoruz
            const uploadedPath = BASE_URL + response.data.data.filePath;

            if (target === 'main') {
                setFormData(prev => ({ ...prev, image: uploadedPath }));
            } else if (target === 'decision') {
                const newDecisions = [...decisions];
                newDecisions[index].image = uploadedPath;
                setDecisions(newDecisions);
            }
        } catch (err) {
            alert("Yükleme hatası: " + (err.response?.data?.message || "Sunucuya ulaşılamadı"));
        }
    };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleDecisionChange = (index, e) => {
        const newDecisions = [...decisions];
        newDecisions[index][e.target.name] = e.target.value;
        setDecisions(newDecisions);
    };

    const addDecision = () => {
        setDecisions([...decisions, { title: '', image: '', winAmount: 0 }]);
    };

    const removeDecision = (index) => {
        if (decisions.length <= 2) return alert("En az 2 seçenek olmalı!");
        const newDecisions = decisions.filter((_, i) => i !== index);
        setDecisions(newDecisions);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const tournamentData = { ...formData, decisions };

        try {
            const response = await api.post('/v1/tournament/', tournamentData, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('JWTTOKEN')}` }
            });
            if (response.data.status === 'success') {
                alert('Turnuva başarıyla oluşturuldu!');
                window.location.href = "/"; // Ana sayfaya dön
            }
        } catch (err) {
            alert('Hata: ' + (err.response?.data?.message || 'Bir sorun oluştu'));
        }
    };

    return (
        <div className="app-container">
            <Navbar />
            <div className="main-content">
                <h2 style={styles.header}>Yeni Turnuva Oluştur</h2>

                <form onSubmit={handleSubmit}>
                    {/* GENEL BİLGİLER */}
                    <div style={styles.card}>
                        <h4 style={styles.cardHeader}>Genel Bilgiler</h4>

                        <label style={styles.label}>Turnuva Başlığı</label>
                        <input name="title" onChange={handleInputChange} style={styles.input} placeholder="Başlık girin..." required />

                        <div style={{ display: 'flex', gap: '20px' }}>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Kategori</label>
                                <select name="category" onChange={handleInputChange} style={styles.select}>
                                    {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                                </select>
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Tür</label>
                                <select name="type" onChange={handleInputChange} style={styles.select}>
                                    {types.map(t => <option key={t} value={t}>{t}</option>)}
                                </select>
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Dil</label>
                                <select name="language" onChange={handleInputChange} style={styles.select}>
                                    {languages.map(t => <option key={t} value={t}>{t}</option>)}
                                </select>
                            </div>
                        </div>

                        <label style={{ ...styles.label, marginTop: '15px' }}>Kapak Görseli</label>
                        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
                            <input type="text" value={formData.image} placeholder="Dosya seçin..." style={styles.input} readOnly />
                            <label style={styles.uploadBtn}>
                                Dosya Seç
                                <input type="file" style={{ display: 'none' }} onChange={(e) => handleFileUpload(e, 'main')} />
                            </label>
                        </div>
                        {formData.image && <img src={formData.image} alt="preview" style={styles.preview} />}
                    </div>

                    <div style={styles.card}>
                        <h4 style={styles.cardHeader}>Turnuva İmport Et</h4>
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Turnuva İd</label>
                                <input name="turnuva_id" onChange={(t) => setApiNo(t.target.value)} style={styles.input} placeholder="ID girin..." required />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Miktar</label>

                                <input name="miktar" onChange={(t) => setCekilecekMiktar(t.target.value)} style={styles.input} placeholder="çekilecek miktar" required />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={styles.label}>Platform</label>
                                <select name="platform" onChange={handleInputChange} style={styles.select}>
                                    <option key={"quizei"} value={"quizei"}>quizei</option>
                                    <option key={"uwufufu"} value={"uwufufu"}>uwufufu</option>
                                </select>
                            </div>

                        </div>





                        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>

                            <label style={styles.uploadBtn}>
                                import
                                <input type="button" style={{ display: 'none' }} onClick={handleUwufufuImport} />
                            </label>
                        </div>



                    </div>


                    {/* SEÇENEKLER */}
                    <div style={{ marginTop: '30px' }}>
                        <h4 style={styles.cardHeader}>Seçenekler (Decisions)</h4>
                        {decisions.map((decision, index) => (
                            <div key={index} style={styles.decisionCard}>
                                <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-end' }}>
                                    <div style={{ flex: 2 }}>
                                        <label style={styles.label}>Seçenek #{index + 1} Başlığı</label>
                                        <input name="title" value={decision.title} onChange={(e) => handleDecisionChange(index, e)} style={styles.input} required />
                                    </div>
                                    <div style={{ flex: 3 }}>
                                        <label style={styles.label}>Görsel</label>
                                        <div style={{ display: 'flex', gap: '5px' }}>
                                            <input value={decision.image} style={styles.input} readOnly placeholder="URL..." />
                                            <label style={styles.uploadBtnSmall}>
                                                Yükle
                                                <input type="file" style={{ display: 'none' }} onChange={(e) => handleFileUpload(e, 'decision', index)} />
                                            </label>
                                        </div>
                                    </div>
                                    <button type="button" onClick={() => removeDecision(index)} style={styles.deleteBtn}>Sil</button>
                                </div>
                            </div>
                        ))}

                        {/* ALT BUTONLAR (Eksik olan kısım burasıydı) */}
                        <div style={styles.actions}>
                            <button type="button" onClick={addDecision} style={styles.addBtn}>
                                + Yeni Seçenek Ekle
                            </button>
                            <button type="submit" style={styles.submitBtn}>
                                Turnuvayı Yayınla
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

const styles = {
    header: { color: 'white', marginBottom: '30px' },
    card: { backgroundColor: '#121212', padding: '20px', borderRadius: '15px', border: '1px solid #252525', marginTop: 20 },
    cardHeader: { color: '#029220', marginBottom: '20px' },
    label: { color: '#b3b3b3', display: 'block', marginBottom: '5px', fontSize: '14px' },
    input: { backgroundColor: '#1e1e1e', color: 'white', border: '1px solid #333', padding: '10px', borderRadius: '8px', width: '100%', marginBottom: '10px' },
    select: { backgroundColor: '#1e1e1e', color: 'white', border: '1px solid #333', padding: '10px', borderRadius: '8px', width: '100%' },
    decisionCard: { backgroundColor: '#181818', padding: '15px', borderRadius: '10px', border: '1px solid #252525', marginBottom: '10px' },
    uploadBtn: { backgroundColor: '#029220', color: 'white', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', height: '42px', display: 'flex', alignItems: 'center' },
    uploadBtnSmall: { backgroundColor: '#333', color: 'white', padding: '0 15px', borderRadius: '8px', cursor: 'pointer', height: '42px', display: 'flex', alignItems: 'center' },
    preview: { width: '100px', height: '100px', borderRadius: '10px', objectFit: 'cover', marginBottom: '10px' },
    deleteBtn: { backgroundColor: '#331111', color: '#ff4d4d', border: '1px solid #442222', padding: '10px', borderRadius: '8px', height: '42px', marginBottom: '10px' },
    actions: { display: 'flex', gap: '20px', marginTop: '30px', paddingBottom: '50px' },
    addBtn: { flex: 1, backgroundColor: 'transparent', color: '#029220', border: '1px solid #029220', padding: '15px', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' },
    submitBtn: { flex: 2, backgroundColor: '#029220', color: 'white', border: 'none', padding: '15px', borderRadius: '10px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer' }
};

export default CreateTournament;